var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page"},[_c('home-hero'),_vm._v(" "),_c('tour-value'),_vm._v(" "),_c('brand-trust'),_vm._v(" "),_c('value-proposition'),_vm._v(" "),_c('proprietary-ems'),_vm._v(" "),_c('ems'),_vm._v(" "),_c('case-studies'),_vm._v(" "),_c('pmg-story'),_vm._v(" "),_c('contact'),_vm._v(" "),_c('main-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a55f2aba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 140
// module chunks = 0